export default "__VITE_ASSET__950cd20e__"